var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label},on:{"blur":function($event){_vm.onBlur()}},model:{value:(_vm.price_model),callback:function ($$v) {_vm.price_model=$$v},expression:"price_model"}})}
var staticRenderFns = []

export { render, staticRenderFns }